import useUser from '@cobliteam/hooks/src/useEntity/useUser';
import { QueryClient } from '@tanstack/react-query';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import type { ReactNode } from 'react';
import { createIDBPersister } from '../persister/createPersister';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 24, // 1 day
    },
  },
});

const ProviderPersistQueryClient = ({ children }: { children: ReactNode }) => {
  const { user, getSession } = useUser();
  const session = getSession();
  const persister = createIDBPersister(`v1_${session?.fleet.id}_${user?.id}`);
  return (
    <PersistQueryClientProvider client={queryClient} persistOptions={{ persister }}>
      {children}
    </PersistQueryClientProvider>
  );
};

export { ProviderPersistQueryClient, queryClient };
